<kiwi-studies-prices [studiesPrices]="parameters"
                     [studiesNames]="studiesNames"
                     [titleLabelKey]="'studies.' + studyType"
                     [arePricesReadonly]="areParametersReadonly()"
                     (saved)="updateParameters()"></kiwi-studies-prices>
